/* eslint no-warning-comments:0 */

import {SEARCH_FUNERAL_HOMES} from '../actions';

/**
 * Updates the funeral homes search store section of the state tree
 * TODO: We do not yet know the nature of the funeral homes store to
 * support faceted search
 * @method  searchFuneralHomesStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */
export default function searchFuneralHomesStore(state = {}, action) {
  switch (action.type) {
    case SEARCH_FUNERAL_HOMES:
      return {...action.data};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/searchFuneralHomesStore.js